import { login } from "../../api/auth";
import LoginForm from "../../components/LoginForm";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const navigate = useNavigate();

  async function handleLogin(email, password) {
    const result = await login(email, password);

    if (result.error) {
      alert(result.message);
      return;
    }

    navigate("/admin/dashboard");
  }

  return <LoginForm onLogin={handleLogin} />;
}
